import React, { useContext, useEffect } from 'react';

import Loading from 'components/Loading';
import MetricCacheContext from 'contexts/MetricCacheContext';
import VisualisationCacheContext from 'contexts/VisualisationCacheContext';

const AllDefinitionsGate = ({ children }: { children: React.ReactNode }) => {
  const {
    requestAllDashboardGadgets,
    allGadgetsLoaded,
    requestAllReportGadgets,
    allReportGadgetsLoaded,
  } = useContext(VisualisationCacheContext);

  const {
    requestAllNormalMetrics,
    requestAllCompoundMetrics,
    allMetricsLoaded,
  } = useContext(MetricCacheContext);

  useEffect(() => {
    requestAllDashboardGadgets();
    requestAllReportGadgets();
    requestAllNormalMetrics();
    requestAllCompoundMetrics();
  }, [
    requestAllDashboardGadgets,
    requestAllReportGadgets,
    requestAllNormalMetrics,
    requestAllCompoundMetrics,
  ]);

  if (!allGadgetsLoaded || !allReportGadgetsLoaded || !allMetricsLoaded) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default AllDefinitionsGate;
